import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["title", "placement", "children", "componentsProps"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Tooltip } from "@mui/material";
import { RaiseColors } from "componentLibrary";

/** Below sticky column (1100) so tooltip is visible on table but hidden behind sticky header; above table body (0). */
import { jsx as _jsx } from "react/jsx-runtime";
var TOOLTIP_Z_INDEX = 100;

/** When true, tooltip uses disablePortal so it stays inside table DOM and respects table stacking (behind sticky, contained). */
export var TableTooltipContext = /*#__PURE__*/React.createContext(false);
var CustomTooltip = function CustomTooltip(_ref) {
  var _componentsPropsProp$, _componentsPropsProp$2, _componentsPropsProp$3, _componentsPropsProp$4;
  var title = _ref.title,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "top-start" : _ref$placement,
    children = _ref.children,
    componentsPropsProp = _ref.componentsProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var inTable = React.useContext(TableTooltipContext);
  var disablePortal = (_componentsPropsProp$ = componentsPropsProp === null || componentsPropsProp === void 0 || (_componentsPropsProp$2 = componentsPropsProp.popper) === null || _componentsPropsProp$2 === void 0 ? void 0 : _componentsPropsProp$2.disablePortal) !== null && _componentsPropsProp$ !== void 0 ? _componentsPropsProp$ : inTable;
  return /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
    placement: placement,
    componentsProps: _objectSpread(_objectSpread({}, componentsPropsProp), {}, {
      tooltip: _objectSpread(_objectSpread({}, componentsPropsProp === null || componentsPropsProp === void 0 ? void 0 : componentsPropsProp.tooltip), {}, {
        sx: _objectSpread({
          padding: "8px 16px",
          backgroundColor: RaiseColors.white,
          borderRadius: "8px",
          maxWidth: "350px",
          minWidth: "160px",
          maxHeight: "200px",
          overflowY: "auto",
          boxShadow: "0px 2px 16px -1px rgba(141, 139, 153, 0.14)",
          zIndex: inTable ? TOOLTIP_Z_INDEX : undefined
        }, componentsPropsProp === null || componentsPropsProp === void 0 || (_componentsPropsProp$3 = componentsPropsProp.tooltip) === null || _componentsPropsProp$3 === void 0 ? void 0 : _componentsPropsProp$3.sx)
      }),
      popper: _objectSpread(_objectSpread({}, componentsPropsProp === null || componentsPropsProp === void 0 ? void 0 : componentsPropsProp.popper), {}, {
        disablePortal: disablePortal
      }, inTable && {
        sx: _objectSpread({
          zIndex: TOOLTIP_Z_INDEX
        }, componentsPropsProp === null || componentsPropsProp === void 0 || (_componentsPropsProp$4 = componentsPropsProp.popper) === null || _componentsPropsProp$4 === void 0 ? void 0 : _componentsPropsProp$4.sx)
      })
    }),
    title: title
  }, props), {}, {
    children: children
  }));
};
export default CustomTooltip;